import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonService } from 'src/app/shared/services/common.service';
declare const google: any;

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsService {

  private autoCompleteService: any;
  private geocoder: any;
  public cityCenter = {};
  private allowedRadius: any;
  cacheDirectionRoutes: Map<any, any> = new Map<any, any>();

  constructor(private commonService: CommonService) {
    this.autoCompleteService = new google.maps.places.AutocompleteService();
    this.geocoder = new google.maps.Geocoder();
    this.commonService.fetchMiscConfig().subscribe(response => {
      if (response && response['cityRadiusInMtrs']) {
        this.allowedRadius = response['cityRadiusInMtrs'];
      }
    });
  }

  findPlaceFromQuery(query: string, city?: string): Observable<any>  {
    return new Observable(observer => {
      this.getCityCenter(city).subscribe((cityCenter) => {
        const request = {
          input: query,
          location: city ? this.cityCenter[city] : null,
          radius: city && this.allowedRadius,
          // componentRestrictions: {country: 'IN'}
        };
        this.autoCompleteService.getPlacePredictions(request, (predictions, status) => {
          if (predictions instanceof Array) {
            observer.next(predictions);
            observer.complete();
          } else {
            throw status;
          }
        });
      });
    });
  }

  getCityCenter(city?: string): Observable<any> {
    return new Observable(observer => {
      if (!city) {
        observer.next(null);
        observer.complete();
      } else if (this.cityCenter[city]) {
        observer.next(this.cityCenter[city]);
        observer.complete();
      } else {
        this.geocoder.geocode({address: city}, (results, status) => {
          if (status === 'OK') {
            this.cityCenter[city] = results[0].geometry.location;
            observer.next(this.cityCenter[city]);
            observer.complete();
          } else {
            throw status;
          }
        });
      }
    });
  }

  getCityBounds(city?: string): Observable<any> {
    return new Observable(observer => {
      this.getCityCenter(city).subscribe((cityCenter) => {
        const boundary = new google.maps.Circle({radius: this.allowedRadius, center: cityCenter});
        observer.next(boundary.getBounds());
        observer.complete();
      });
    });
  }

  getLocationBounds(latLng: any, radius?: any): Observable<any> {
    const boundary = new google.maps.Circle({radius: radius || 3000, center: latLng});
    return boundary.getBounds();
  }

  getPlaceGeoCode(placeId: string): Observable<any> {
    return new Observable(observer => {
      this.geocoder.geocode({placeId}, (results, status) => {
        if (status === 'OK') {
          const geoCord = `${results[0].geometry.location.lat()},${results[0].geometry.location.lng()}`;
          observer.next(geoCord);
          observer.complete();
        }
      });
    });
  }

  checkLocationInCity(city: string, place: any): Observable<any> {
    return new Observable(observer => {
      this.getCityCenter(city).subscribe((center) => {
        if (place.geoCord) {
          const locationLatLng = this.convertToLatLong(place.geoCord);
          const distance = google.maps.geometry.spherical.computeDistanceBetween(center, locationLatLng);
          const isWithinBounds = distance > this.allowedRadius ? false : true;
          observer.next(isWithinBounds);
        } else if (place.city) {
          observer.next(place.city === city);
        } else {
          observer.next(true);
        }
        observer.complete();
      });
    });
  }

  convertToLatLong(geoCord: string) {
    const geoCordArr = geoCord.split(',');
    return new google.maps.LatLng(Number(geoCordArr[0]), Number(geoCordArr[1]));
  }

  computeHeadingFromMilestones(allMileStones) {
    if (allMileStones.length > 0) {
      const lastMilestone = allMileStones[allMileStones.length - 1];
      let prevMilestone = allMileStones[0];
      for (let i = allMileStones.length - 2; i > 0; i--) {
        if (!lastMilestone.equals(allMileStones[i])) {
          prevMilestone = allMileStones[i];
          break;
        }
      }
      return google.maps.geometry.spherical.computeHeading(prevMilestone, lastMilestone);
    } else {
      return 0;
    }
  }

  getNewDirectionsRenderer() {
    return new google.maps.DirectionsRenderer({
      suppressMarkers: true,
      preserveViewport: true,
      polylineOptions: {
        strokeColor: '#425365',
        strokeOpacity: 1,
        strokeWeight: 4
      }
    });
  }

  getNewPolyline() {
    return new google.maps.Polyline({
      strokeColor: '#11c0ef',
      strokeOpacity: 1,
      strokeWeight: 4,
      path: new google.maps.MVCArray([]),
      zIndex: 1
    });
  }

  getDistanceToAPoint(matrix, point) {
    let duration = 0;
    for (let i = 0; i < (point); i++) {
      duration += matrix['rows'][i]['elements'][i + 1]['duration']['value'];
    }
    return duration;
  }
}

